<mat-card class="w-full">
    <mat-card-header>
        <mat-card-title>
            <img alt="SmartPart Edge" class="logo-login mb-2" mat-card-image ngSrc="./assets/app-logo.svg" height="117"
                 width="659">
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form (submit)="tryLogin()" [formGroup]="loginForm">
            <mat-form-field class="form-field-full-width">
                <input autocomplete="username email" class="form-group" formControlName="email" matInput
                       placeholder="Email" required type="text">
                @if (loginForm.get('email').hasError('required')) {
                    <mat-error>Email is required</mat-error>
                }
                @if (loginForm.get('email').hasError('email')) {
                    <mat-error>Invalid email</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="form-field-full-width">
                <input autocomplete="current-password" class="form-group" formControlName="password" matInput
                       placeholder="Password" required type="password">
                <mat-error>Password is required</mat-error>
            </mat-form-field>
            <div class="flex items-center justify-center gap-2">
                <button [disabled]="loginForm.invalid" color="primary" mat-raised-button type="submit">Log in
                </button>
            </div>
            <div class="button-row reset-password"><a mat-button routerLink="/forgot-password">Reset Password</a>
            </div>
        </form>
    </mat-card-content>
</mat-card>
